import {isNil} from 'ramda';

const SESSION_ID_STORAGE_KEY_PREFIX = 'online-offer-session-id';
const OPENED_BY_EMAIL = 'email';
const inMemorySessionIds = new Map<string, string>();

const getStorageKey = (offerId: string) => `${SESSION_ID_STORAGE_KEY_PREFIX}:${offerId}`;

/**
 * Returns a stable per-browser-session anonymous id for a customer-opened offer.
 * Seller previews (openedBy !== 'email') get null and must not emit engagement.
 */
export const getOnlineOfferSessionId = (args: {
  offerId: string;
  openedBy: string | null;
}): string | null => {
  if (args.openedBy !== OPENED_BY_EMAIL) {
    return null;
  }
  const key = getStorageKey(args.offerId);
  try {
    const existing = window.sessionStorage.getItem(key);
    if (!isNil(existing)) {
      return existing;
    }
    const created = window.crypto.randomUUID();
    window.sessionStorage.setItem(key, created);
    return created;
  } catch {
    const existing = inMemorySessionIds.get(key);
    if (!isNil(existing)) {
      return existing;
    }
    const created = window.crypto.randomUUID();
    inMemorySessionIds.set(key, created);
    return created;
  }
};
